module.exports = require("sweetalert2");